module.exports = __webpack_public_path__ + "static/media/wallE.2d6106ce.jpg";